import { AlertTakeoverCampaign } from 'modules/campaigns/lib/takeovers/AlertTakeover/types';
import { CampaignTypeFilter, MessageMedium } from 'modules/domains/campaign';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface CampaignAlertJourneyContextState {
  alertDetails: string[];
  campaignData: AlertTakeoverCampaign;
  hasProjectAlerts: boolean;
  isAlertTakeoverOpen: boolean;
  isLoadingAlerts: boolean;
  onTakeoverOpen: (isOpen: boolean) => void;
  refetchCampaignAlerts: () => void;
}

export const DEFAULT_ALERT_TAKEOVER_CONTEXT_STATE: CampaignAlertJourneyContextState = {
  alertDetails: [],
  campaignData: {
    campaignId: 0,
    name: '',
    messageMedium: MessageMedium.Email,
    campaignType: CampaignTypeFilter.Triggered,
  },
  hasProjectAlerts: false,
  isAlertTakeoverOpen: false,
  isLoadingAlerts: false,
  onTakeoverOpen: noop,
  refetchCampaignAlerts: noop,
};

export const CampaignAlertJourneyContext = createContext<CampaignAlertJourneyContextState>(
  DEFAULT_ALERT_TAKEOVER_CONTEXT_STATE,
);

export const useCampaignAlertJourneyContext = () => useContext(CampaignAlertJourneyContext);
